"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SlidingPanelDropdown = exports.SlidingPanelSection = exports.SlidingPanelHeader = exports.SlidingPanel = exports.ToggleIcon = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./SlidingPanel.css");
var FilterVariantIcon_1 = __importDefault(require("mdi-react/FilterVariantIcon"));
var ArrowRightIcon_1 = __importDefault(require("mdi-react/ArrowRightIcon"));
var ChevronRightIcon_1 = __importDefault(require("mdi-react/ChevronRightIcon"));
var Button_1 = require("../Button");
var R = __importStar(require("ramda"));
var Badge = function (_a) {
    var children = _a.children;
    return react_1["default"].createElement("div", { className: "vs-sliding-panel-badge" }, children);
};
var removeUnrelatedProps = R.omit([
    'initialActive',
    'syncStateToOpen',
    'expandFilterDropdown',
    'hideFilterDropdown',
    'toggleSlidingPanel',
    'setSlidingPanelActiveState',
]);
var ToggleIcon = function (_a) {
    var onClick = _a.onClick, hoverText = _a.hoverText, toggleIconState = _a.toggleIconState, className = _a.className, restProps = __rest(_a, ["onClick", "hoverText", "toggleIconState", "className"]);
    var Icon = toggleIconState ? ArrowRightIcon_1["default"] : FilterVariantIcon_1["default"];
    return (react_1["default"].createElement("a", __assign({}, restProps, { className: "vs-sliding-panel-toggle-icon ".concat(className), onClick: onClick, title: hoverText }),
        react_1["default"].createElement(Button_1.Button, { type: "inline-outline-secondary" },
            react_1["default"].createElement(Icon, { className: "vs-sliding-panel-section-icon" }))));
};
exports.ToggleIcon = ToggleIcon;
var SlidingPanel = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, active = _a.active, restProps = __rest(_a, ["className", "children", "active"]);
    return (react_1["default"].createElement("div", __assign({ className: (0, classnames_1["default"])("".concat(className, " vs-sliding-panel"), {
            'vs-active': active
        }) }, removeUnrelatedProps(restProps)),
        react_1["default"].createElement("ul", { className: "vs-force-sliding-panel-width" }, children)));
};
exports.SlidingPanel = SlidingPanel;
var SlidingPanelHeader = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, restProps = __rest(_a, ["className", "children"]);
    return (react_1["default"].createElement("li", __assign({ className: "".concat(className, " vs-sliding-panel-header") }, restProps), children));
};
exports.SlidingPanelHeader = SlidingPanelHeader;
var SlidingPanelSection = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, restProps = __rest(_a, ["className", "children"]);
    return (react_1["default"].createElement("li", __assign({ className: "".concat(className, " vs-sliding-panel-section") }, restProps), children));
};
exports.SlidingPanelSection = SlidingPanelSection;
var SlidingPanelDropdown = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, label = _a.label, children = _a.children, onClick = _a.onClick, badge = _a.badge, expanded = _a.expanded, _c = _a.id, id = _c === void 0 ? '' : _c, restProps = __rest(_a, ["className", "label", "children", "onClick", "badge", "expanded", "id"]);
    var containerClasses = (0, classnames_1["default"])("".concat(className, " vs-sliding-panel-section-container"), {
        'vs-expanded': expanded
    });
    var optionsClasses = (0, classnames_1["default"])('vs-sliding-panel-section-options', {
        'vs-expanded': expanded
    });
    return (react_1["default"].createElement("ul", __assign({ className: containerClasses, id: id }, removeUnrelatedProps(restProps)),
        react_1["default"].createElement("li", null,
            react_1["default"].createElement("a", { onClick: onClick, className: "vs-sliding-panel-section-container-label" },
                react_1["default"].createElement("div", { className: "vs-sliding-panel-section-label" },
                    label,
                    badge && react_1["default"].createElement(Badge, null, badge)),
                react_1["default"].createElement("div", { className: "vs-sliding-panel-chevron-container" },
                    react_1["default"].createElement(ChevronRightIcon_1["default"], null)))),
        react_1["default"].createElement("ul", null,
            react_1["default"].createElement("div", { className: optionsClasses }, children))));
};
exports.SlidingPanelDropdown = SlidingPanelDropdown;
